const firstJobsComponent = document.querySelector('.first-jobs-section');
if (firstJobsComponent) {
  const advancedToggle = firstJobsComponent.querySelector(
    '.first-jobs-section__form-toggle'
  );
  const advancedContent = firstJobsComponent.querySelector(
    '.first-jobs-section__form-hidden'
  );

  if (advancedToggle) {
    advancedToggle.addEventListener('click', () => {
      if (!advancedToggle.classList.contains('active')) {
        advancedToggle.classList.add('active');
        advancedContent.classList.add('active');

        setTimeout(function () {
          advancedContent.classList.add('is-visible');
        }, 150);
      } else {
        advancedToggle.classList.remove('active');
        advancedContent.classList.remove('active');

        setTimeout(function () {
          advancedContent.classList.remove('is-visible');
        }, 150);
      }
    });
  }
}

const jobsWithListSecArr = document.querySelectorAll('.jobs-with-list-sec');
if (jobsWithListSecArr.length) {
  jobsWithListSecArr.forEach((jobsWithListSec) => {
    const jobsList = jobsWithListSec.querySelector('.jobs-section__jobs-list');
    const jobsCards = jobsList.querySelectorAll('.job-card');

    jobsWithListSec.classList.forEach((className) => {
      if (className.startsWith('jobs-count-')) {
        jobsWithListSec.classList.remove(className);
      }
    });

    jobsWithListSec.classList.add(`jobs-count-${jobsCards.length}`);
  });
}

updateJobsCountClasses();

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    updateJobsCountClasses();
  }, 200);
});

function updateJobsCountClasses() {
  jobsWithListSecArr.forEach((jobsWithListSec) => {
    const jobsList = jobsWithListSec.querySelector('.jobs-section__jobs-list');
    const jobsCards = jobsList.querySelectorAll('.job-card');

    jobsWithListSec.classList.forEach((className) => {
      if (className.startsWith('jobs-count-')) {
        jobsWithListSec.classList.remove(className);
      }
    });

    jobsWithListSec.classList.add(`jobs-count-${jobsCards.length}`);
  });
}
